export default (values) => {
  const errors = {}
  const { confirmPassword, password } = values
  if (typeof password === 'undefined' || password === '') {
    errors.password = 'Password must not be empty'
  } else if (password.length < 12) {
    errors.password = 'Password must be at least 12 characters long'
  }
  if (password && password !== confirmPassword) {
    errors.confirmPassword = 'Password does not match'
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/smart-components/reset-password-form/validate.js